import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  LedgerAccountSelector,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelector'

import { WizardManualAccountData } from '../../types'
import { WizardStepLayout } from '../WizardStepLayout'

export const LedgerAccountLinkStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardManualAccountData>) => {
  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_2.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_2.subtitle')}
    >
      <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
        <Text.Normal color="grey1000" weight="medium">
          {i18n.t('banking.accounts.accounting.ledger_account')}
        </Text.Normal>
        <Text color="grey800" weight="normal" size="200">
          {i18n.t('banking.accounts.accounting.accounting_account_label')}
        </Text>{' '}
        <Box>
          {data.legalEntityId && (
            <LedgerAccountSelector
              legalEntityId={data.legalEntityId}
              currentLedgerAccountName={data.ledgerAccountName}
              types={['bank']}
              disabled={false}
              onSelect={(id) => null}
              onEntitySelect={(entity) => {
                onDataChanged({
                  ...data,
                  ledgerAccountId: entity?.id ?? null,
                  ledgerAccountName: formatAccountName(entity) ?? null,
                })
              }}
            />
          )}
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
